<template>
  <div />
</template>

<script setup lang="ts">
import { useEventBus } from '@vueuse/core'
import { useToast } from 'primevue/usetoast'
import { onMounted, onBeforeUnmount } from 'vue'
import type { Notification } from '~/shared/types/notification'

// Use PrimeVue's toast system
const toast = useToast()

// Listen to the notification event bus
const newNotificationBus = useEventBus<Notification>('new-notification')

// Handler for new notifications
const handleNewNotification = (notification: Notification) => {
  // Determine severity based on priority
  let severity: 'success' | 'info' | 'secondary' | 'warn' | 'error' | 'contrast' | undefined = 'info'
  if (notification.priority === 'high') severity = 'warn'
  if (notification.priority === 'low') severity = 'success'

  // Display the toast
  toast.add({
    severity,
    summary: notification.title,
    detail: notification.body,
    life: 5000, // 5 seconds

  })
}

// Set up and clean up event listeners
onMounted(() => {
  newNotificationBus.on(handleNewNotification)
})

onBeforeUnmount(() => {
  newNotificationBus.off(handleNewNotification)
})
</script>
